import { useState } from "react"
import toast from "react-hot-toast"
import { ContextMenu } from '../../../../components/menus/contextMenu/ContextMenu'
import { translations } from "../../../../configs/translations"
import { DonateItem } from "../../../../models/DonateItem"
import UserService from "../../../../services/UserService"
import { useStore } from "../../../../store/store"
import './InventoryCard.css'

export const InventoryCard = ({ item, onButtonClick, isContextMenuOpen, setContextMenuOpen, closeAllMenues, fetchItems }: { item: DonateItem; onButtonClick: () => void; isContextMenuOpen: boolean; setContextMenuOpen: (isOpen: boolean) => void; closeAllMenues: () => void; fetchItems: () => void }) => {
    const language = useStore(state => state.language) as keyof typeof translations
    const t = translations[language]

    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 })

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault()
        closeAllMenues()

        setContextMenuPosition({ x: e.clientX, y: e.clientY })
        setContextMenuOpen(true)
        onButtonClick()
        setTimeout(() => {
            handleContextMenu(e)
        }, 50)
    }

    const handleContextMenu = (e: React.MouseEvent) => {
        e.preventDefault()
        closeAllMenues()
        setContextMenuPosition({ x: e.clientX, y: e.clientY })
        setContextMenuOpen(true)
    }

    return (
        <div
            className="inventory-card-container"
            onClick={handleClick}
            onContextMenu={handleContextMenu}
        >
            <div className="inventory-card-image">
                <div className="inventory-card-image-car">
                    <img
                        src={`./cases/prizes/${item.item.name || item.type}.png`}
                        alt={item.item.name || item.type}
                    />
                </div>
            </div>

            <div className="inventory-card-content">
                <h3 className="inventory-card-title">{item.item.name || item.type}</h3>
            </div>

            {isContextMenuOpen && (
                <ContextMenu
                    isOpen={isContextMenuOpen}
                    position={contextMenuPosition}
                    setIsOpen={setContextMenuOpen}
                    items={getContextMenuItems(item, t, closeAllMenues, fetchItems, setContextMenuOpen)}
                    onClose={() => setContextMenuOpen(false)}
                />
            )}
        </div>
    )
}

const getContextMenuItems = (
    itemData: DonateItem,
    t: typeof translations[keyof typeof translations],
    closeAllMenues: () => void,
    fetchItems: () => void,
    setContextMenuOpen: (isOpen: boolean) => void
) => {

    const items = []

    if (itemData.type === 'PRIZE') {

        const handleApplyPrize = () => {
            UserService.applyPrize(itemData.item.caseId)
                .catch((error) => {

                    toast.error(
                        error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                            ? t[error.response.data as keyof typeof t]
                            : t.error_unknown,
                        { className: 'notification-error' }
                    )
                })
                .finally(() => {
                    fetchItems()
                    closeAllMenues()
                })
        }

        const scrapSound = new Audio('./sounds/scrap.mp3')
        const handleDiscardPrize = () => {
            scrapSound.play()
            UserService.discardPrize(itemData.item.caseId)
                .catch((error) => {
                    toast.error(
                        error && error.response && error.response.data && t[error.response.data as keyof typeof t]
                            ? t[error.response.data as keyof typeof t]
                            : t.error_unknown,
                        { className: 'notification-error' }
                    )
                })
                .finally(() => {
                    fetchItems()
                    closeAllMenues()
                })
        }

        const applyButton = (
            <div
                style={{ fontSize: '0.8rem' }}
                onClick={(e) => {
                    handleApplyPrize()
                    e.stopPropagation()
                }}>
                {t.context_menu_donate_inventory_prize_apply}
            </div>
        )

        const discardButton = (
            <div
                onClick={(e) => {
                    handleDiscardPrize()
                    e.stopPropagation()
                }}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    width: '100%',
                    height: '100%',
                    fontSize: '0.8rem'
                }}
            >
                {t.context_menu_donate_inventory_prize_discard}

                <div
                    style={{
                        display: 'flex',
                    }}
                >
                    <img
                        style={{
                            width: '16px',
                            height: '16px'
                        }}
                        src="./icons/32px/scrap.png" alt="scrap"
                    />
                    <p style={{ fontWeight: 'bold' }}>{itemData.item.discardCost}</p>

                </div>
            </div>
        )

        items.push(applyButton, discardButton)
    }

    return items
}